import { privateApi } from 'api'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { EBannerStatus, EBannerType, IBanner } from 'models/banners'
import { getNormalizedFormData } from 'shared/utils/getNormalizedFormData'

interface CreateBannerBody {
  photo?: File
  video?: File // баннер — либо фото, либо видео; одно из двух обязательно
  fixed_position?: boolean
  end_date?: string // YYYY-MM-DD
  type: EBannerType
  video_loop?: boolean
  webUrl?: string
  scrollDown?: boolean
  navigation_path?: string
  page_id?: string // привязка к лендинг-странице (напр. ПолоКлуб)
}

// при редактировании фото опционально: не передано — оставляем прежнее
interface UpdateBannerBody {
  photo?: File
  video?: File // новый файл заменяет прежнее фото или видео
  fixed_position?: boolean
  end_date?: string // YYYY-MM-DD
  type?: EBannerType
  video_loop?: boolean
  webUrl?: string
  scrollDown?: boolean
  navigation_path?: string
}

export const bannersApi = {
  // page — slug лендинг-страницы; без него возвращаются баннеры главной
  getBanners: (page?: string): Promise<AxiosResponse<IBanner[]>> => {
    return privateApi.get('/admin/banner', { params: page ? { page } : {} })
  },
  // config — отмена (signal) и прогресс загрузки файла
  createBanner: (data: CreateBannerBody, config?: AxiosRequestConfig) => {
    const formData = getNormalizedFormData(data)
    return privateApi.post('/admin/banner', formData, config)
  },
  updateBannerStatus: (id: string, status: EBannerStatus) => {
    return privateApi.patch('/admin/banner', { status }, { params: { _id: id } })
  },
  updateBanner: (id: string, data: UpdateBannerBody, config?: AxiosRequestConfig) => {
    const formData = getNormalizedFormData(data)
    return privateApi.patch('/admin/banner', formData, { ...config, params: { _id: id } })
  },
  // ids — незакреплённые активные баннеры в новом порядке; page — slug лендинга
  reorderBanners: (ids: string[], page?: string) => {
    return privateApi.patch('/admin/banner/order', { ids }, { params: page ? { page } : {} })
  },
  deleteBanner: (id: string) => {
    return privateApi.delete('/admin/banner', { params: { _id: id } })
  }
}
